import {
  ACTION_ON_RULE_VIOLATION_TYPE_FETCH_REQUEST,
  ACTION_ON_RULE_VIOLATION_TYPE_FETCH_REQUEST_FAILURE,
  ACTION_ON_RULE_VIOLATION_TYPE_FETCH_REQUEST_SUCCESS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */

const channelActionOnRuleViolationTypesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case ACTION_ON_RULE_VIOLATION_TYPE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case ACTION_ON_RULE_VIOLATION_TYPE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case ACTION_ON_RULE_VIOLATION_TYPE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    default:
      return state;
  }
};

export default channelActionOnRuleViolationTypesReducer;
